import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { IconButton } from '@material-ui/core';
import {
  Brightness4 as MoonIcon,
  Brightness7 as SunIcon,
} from '@material-ui/icons';
const useStyles = makeStyles((theme) => ({
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
  },
  title: {
    flexGrow: 1,
  },
}));

export default function TopMenu() {
  const classes = useStyles();

  const { palette, toggleDark } = useTheme();

  return (
    <AppBar position="fixed" className={classes.appBar}>
      <Toolbar>
        <Typography variant="h6" className={classes.title}>
          Task Manager
        </Typography>
        <IconButton onClick={toggleDark}>
          {palette.type === 'dark' ? <SunIcon /> : <MoonIcon />}
        </IconButton>
      </Toolbar>
    </AppBar>
  );
}
